/** Subtle UI sounds, off by default (a per-device choice in the settings pill). */
export const SOUND_KEY = "uz.world.sound";

export function soundEnabled(): boolean {
  try {
    return globalThis.localStorage?.getItem(SOUND_KEY) === "1";
  } catch {
    return false;
  }
}

export function setSoundEnabled(on: boolean): void {
  try {
    globalThis.localStorage?.setItem(SOUND_KEY, on ? "1" : "0");
  } catch {
    // Blocked storage: the choice lasts for this visit only.
  }
}

let ctx: AudioContext | null = null;

/** A short soft blip: `up` rises (open, enter), `down` falls (close, exit). */
export function playUi(kind: "up" | "down" | "tick" = "tick"): void {
  if (!soundEnabled()) return;
  try {
    const Ctor =
      globalThis.AudioContext ??
      (globalThis as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctor) return;
    ctx ??= new Ctor();
    const now = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    const [from, to] = kind === "up" ? [440, 660] : kind === "down" ? [600, 400] : [520, 520];
    osc.type = "sine";
    osc.frequency.setValueAtTime(from, now);
    osc.frequency.linearRampToValueAtTime(to, now + 0.09);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.05, now + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.12);
    osc.connect(gain).connect(ctx.destination);
    osc.start(now);
    osc.stop(now + 0.14);
  } catch {
    // No audio device or blocked by autoplay policy: sounds are optional.
  }
}
